import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { SpacerComponent } from '@sirius/common';
import { MediaContent } from 'matchmaking/models';
import { InterpolatePipe } from 'shared/pipes';
import { MatchmakingTranslateService } from 'matchmaking/services';
import { ItemSliderOrGridViewComponent } from 'shared';

@Component({
    selector: 'matchmaking-case-stories',
    imports: [InterpolatePipe, ItemSliderOrGridViewComponent, SpacerComponent],
    templateUrl: './case-stories.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './case-stories.component.scss'
})
export class CaseStoriesComponent {
    translationService = inject(MatchmakingTranslateService);

    caseStories = input.required<MediaContent[]>();
    application = input<string>();

    translations = computed(() => this.translationService.translations());

    cardItems = computed(() => {
        if (!this.caseStories()?.length) {
            return [];
        }

        const items: any[] = [];

        this.caseStories().forEach((story: MediaContent) => {
            story.media.forEach((media) => {
                items.push(media);
            });
        });

        return items;
    });
}
